import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.scss';
import './i18n'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './ReduxToolkit/Store';

import { applyColorMode, readColorMode } from './Utils/colorMode';

applyColorMode(readColorMode());

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <App />
    </Provider>
  </QueryClientProvider>
);


reportWebVitals();





// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import { Provider } from 'react-redux';
// import './index.scss';
// import './i18n'
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import { store } from './ReduxToolkit/Store';

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );

// root.render(
//   <Provider store={store}>
//     <App />
//   </Provider>
// );


// reportWebVitals();

